import styled from 'styled-components';
import { Button, withFancyHorizontalScrollbar } from '../base';
import media from '../base/media';

export const FiltersWrapper = styled.div`
	margin-bottom: 2rem;

	${media.desktopSmall`
		display: flex;
		align-items: center;
		max-width: 1920px;
		margin: 0 auto;
		margin-bottom: 4rem;
	`}
`;

export const Count = styled.div`
	padding-left: 1rem;
	color: ${props => props.theme.colors.gray};

	> span:first-child {
		display: inline-block;
		margin-right: 5px;
	}

	${media.desktopSmall`
		padding: 0 4rem;
	`}
`;

export const Buttons = styled.div`
	${media.tablet`
		display: flex;
	`}
`;

export const ButtonWrapper = styled.div`

`;

export const LocationPriceWrapper = styled.div`
	display: flex;
	margin-bottom: 2rem;
`;

export const TitleCountWrapper = styled.div`
	display: flex;
	margin-bottom: 2rem;
`;

export const LocationButton = styled(Button)`
	margin-right: 1rem;
`;

export const PriceButton = styled(Button)`
	margin-right: 1rem;
`;

export const RoomCountWrapper = styled.div`
	overflow-x: auto;
	${withFancyHorizontalScrollbar};
`;

export const ClearWrapper = styled.div`
	display: flex;
	margin-top: 1rem;

	${media.tablet`
		margin-top: 0;
		margin-left: 1rem;
	`};
`;
